import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type TreeFilter,
} from '../types/filters';
import { companyDefinition, companyHandler } from './company';

export const multiCompanyDefinition: FilterDefinition<MultiFilter<TreeFilter>> =
  {
    id: FilterId.MULTI_COMPANY,
    name: 'Company & Industry',
    type: FilterType.MULTI,
    wrappedFilterId: FilterId.COMPANY,
    instances: [],
    isVisible: true,
  };

export const multiCompanyHandler: FilterHandler<MultiFilter<TreeFilter>> = {
  isActive(currentFilterState: MultiFilter<TreeFilter>) {
    return currentFilterState.instances.some((instance) =>
      companyHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<TreeFilter>,
    _definition: FilterDefinition<MultiFilter<TreeFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<TreeFilter>,
    _definition: FilterDefinition<MultiFilter<TreeFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      companyHandler.getEffectiveFilter(instance, companyDefinition, config)
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
